// @ts-nocheck


import { fetchRequest } from './index';

import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';

const convertDataToServer = (sideServiceTariff) => ({
  ...sideServiceTariff,
  price: convertFromRubToKop(sideServiceTariff.price)
});
const convertDataFromServer = (sideServiceTariff) => ({
  ...sideServiceTariff,
  price: convertFromKopToRub(sideServiceTariff.price)
});
const baseUrl = 'sideServiceTariff';
const sideServiceTariff = new CommonApi(
  baseUrl,
  'тарифы для услуг на сторону',
  convertDataToServer,
  convertDataFromServer
);
const current = async (params) => {
  const sideServiceTariff = await fetchRequest.get(`/${baseUrl}/current`, {
    ...params
  });
  if (sideServiceTariff) return convertDataFromServer(sideServiceTariff);
  return null;
};
export default { ...sideServiceTariff, current };
